<div class="chat-panel-container" 
    (keydown.enter)="onEnterKey($any($event))">
     <p class="chat-panel-item-title">Common Prompts:</p>
    <p *ngIf="filteredPrompts.length === 0" class="no-prompts-message">
      No prompts available. Please type your question below.
    </p>
        <div *ngIf="filteredPrompts.length > 0" class="chat-panel-item">
       
        <mat-chip-listbox class="chat-panel-chips">
                <mat-chip *ngFor="let prompt of (isSeeMore ? filteredPrompts.slice(0,maxPrompts) : filteredPrompts.slice(0, 3))"
                    color="accent" (click)="selectPrompt(prompt)">
                <span class="chat-panel-chip-text">{{ prompt }}</span>
            </mat-chip>
        </mat-chip-listbox>
         <span class="chat-panel-item-see-more"
      *ngIf="filteredPrompts.length > 3"
      (click)="seeMore()">
  {{ isSeeMore ? 'See Less' : 'See All Prompts' }}
</span>

    </div>
    <div class="chat-panel-item">
        <mat-form-field appearance="outline" style="width: 100%; margin-top: 10px;">
            <mat-label>Type your question here.</mat-label>
            <textarea matInput style="min-height: 200px; width: 100%; border: 1px solid;" [ngModel]="message" (ngModelChange)="message=$event"></textarea>
        </mat-form-field>
        <mat-error class="chat-panel-error" *ngIf="error">
            <mat-icon color="warn">warning</mat-icon> 
            <p>Network error</p>
        </mat-error>
        <app-button [configKey]="message ? 'submitQuestion' : 'submitQuestionDisabled'" [isLoading]="isLoading" (onClick)="handleClick()"></app-button>
    </div>
</div>